/**
 * API health store — which background reads failed on the current page.
 *
 * The analytics / prediction / intelligence API modules degrade to a neutral shape
 * on error so a page never hard-crashes. The cost was that a dead endpoint and an
 * empty result looked the same: a 500 became "no data". `safeGet` now records every
 * failure here and clears it when the same call succeeds again; the
 * `DataHealthBanner` in the layout tells the manager the figures may be incomplete.
 *
 * @module stores/useApiHealthStore
 */
import { create } from 'zustand';

export const useApiHealthStore = create((set, get) => ({
  /** { [url]: { url, status, at, path } } — one entry per failing endpoint */
  failures: {},

  /** A read failed: remember it under the page it happened on. */
  reportFailure: (url, status) => {
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    set((s) => ({ failures: { ...s.failures, [url]: { url, status: status ?? null, at: Date.now(), path } } }));
  },

  /** The same read succeeded afterwards: the page is healthy again for it. */
  resolve: (url) => {
    if (!get().failures[url]) return;
    set((s) => {
      const next = { ...s.failures };
      delete next[url];
      return { failures: next };
    });
  },

  /** Route change or manual dismiss. */
  clear: () => set({ failures: {} }),
}));
